import PropTypes from 'prop-types'

const PublisherIcon = ({ title }: any) => (
  <svg className="publisher-icon" viewBox="0 0 112 109" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>{title}</title>
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stopColor="#B4EC51" offset="0%" />
        <stop stopColor="#429321" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
      <g
        id="publisher-landing-page"
        transform="translate(-984.000000, -162.000000)"
        stroke="url(#linearGradient-1)"
        strokeWidth="2"
      >
        <g id="content-copy-3">
          <g id="custom-connectors" transform="translate(334.000000, 86.000000)">
            <g id="icon-people-talking" transform="translate(651.000000, 77.000000)">
              <polygon id="Shape" points="110 0 48 0 48 51 66.2352941 36.4285714 110 36.4285714" />
              <circle id="Oval" cx="88" cy="62" r="11" />
              <circle id="Oval" cx="22" cy="62" r="11" />
              <path
                d="M44,107 L44,96.0641667 C44,93.4608333 42.6341667,91.0665 40.3938333,89.741 C36.828,87.6308333 30.646,85 22,85 C13.2421667,85 7.1005,87.6143333 3.57133333,89.7208333 C1.34933333,91.0481667 0,93.4351667 0,96.0238333 L0,107 L44,107 Z"
                id="Shape"
              />
              <path
                d="M110,107 L110,96.0641667 C110,93.4608333 108.634167,91.0665 106.393833,89.741 C102.828,87.6308333 96.646,85 88,85 C79.2421667,85 73.1005,87.6143333 69.5713333,89.7208333 C67.3493333,91.0481667 66,93.4351667 66,96.0238333 L66,107 L110,107 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

PublisherIcon.displayName = 'PublisherIcon'

PublisherIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

PublisherIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'Publisher'
}

export default PublisherIcon
